
import {  moneyFormatter } from "./MoneyFormatter";
import type { MoneyFormatter } from "./MoneyFormatter";
import type { Translation, Translator } from "./Translator";
import { RobotPlay } from './RobotPlay';
import { IOManager } from "./IO";
import { MultigameSlotServerHub } from "./api";
import { HubConnection } from "@microsoft/signalr";
import { BackendSettings } from "./help/Help";
import { SinglegameServerHub } from "../singlegame/singlegame_api";


export interface ApiConnection
{
    connection: HubConnection;
    connected: boolean;
}

export interface Services
{
    moneyFormatter: MoneyFormatter;
    // protocol: Protocol;

    apiConnection: ApiConnection;
    api: MultigameSlotServerHub;
    onlineApi: SinglegameServerHub;

    translation: Translation;
    translator: Translator;
    robotPlay : RobotPlay;

    iomanager: IOManager;
    backendSettings: BackendSettings;
}

function createServices(): Services
{
    return {
        moneyFormatter: moneyFormatter,
        // protocol: null,

    apiConnection: null,
    api: null,
    onlineApi: null,

        translation: null,
        translator: null,
        robotPlay: null,

        iomanager: new IOManager(),
        backendSettings: null
    };
}

const SERVICE_KEY = Symbol.for("service");

// Use ??= so re-imports or HMR re-executions don’t recreate the object
export const service: Services = (globalThis[SERVICE_KEY] ??= createServices());
